import "./styles/colors_and_type.css";
import "./styles/gift-card.css";
import { mountGiftCard } from "./gift-card.js";

mountGiftCard();
